import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const SUPPORT_EMAIL = "delivery@gortonsuperstore.uk";

export default function RefundsPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="refunds-page">
      <Header />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <Link
          to="/"
          className="inline-flex items-center text-slate-600 hover:text-emerald-600 mb-8 text-sm"
          data-testid="refunds-back-link"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">
          Refund and Returns Policy
        </h1>

        <div className="prose prose-slate max-w-none space-y-5 text-slate-700 leading-relaxed">
          <p>
            We always strive to ensure all our customers have an exemplary service when
            shopping with us.
          </p>
          <p>
            Should your order arrive damaged or missing, please contact us at{" "}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-emerald-600 hover:underline"
            >
              {SUPPORT_EMAIL}
            </a>
            , and we will immediately try to rectify. Please note though, that we can
            only offer refunds for items if they arrive damaged, or missing.
          </p>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Non-Perishable Items — 14 Days
            </h2>
            <p>
              Our refund and returns policy for Non-Perishable items lasts{" "}
              <strong>14 days from delivery</strong>. If 14 days have passed since your
              purchase, we cannot offer you a refund or exchange.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Perishable Items — 24 Hours
            </h2>
            <p>
              Our refund and returns policy for Perishable items is{" "}
              <strong>24 hours from delivery</strong>. For Perishable items (plantains,
              bread, etc.) please contact us within 24 hours of delivery of your order
              to advise of missing and/or damaged items. If 24 hours have passed since
              your purchase was delivered, we cannot offer you a refund or exchange.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              How We Process Refunds
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                We may request a photograph showing the problem if it is something that
                can be seen by inspecting the Items.
              </li>
              <li>
                We will provide a refund or account credit in respect of the affected
                part of the Item(s).
              </li>
              <li>
                Should you wish to return an item, you will be responsible for paying
                for your own delivery costs for returning your item. Delivery costs are
                non-refundable. If you receive a refund, the cost of return delivery
                will be deducted from your refund.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Product Packaging
            </h2>
            <p>
              Please note that Products or product packages may differ slightly to those
              displayed on our website, and should you have any doubt about any product
              please contact us.
            </p>
          </section>

          <section className="bg-emerald-50 border border-emerald-200 rounded-xl p-6 mt-10">
            <h2 className="text-xl font-semibold text-emerald-900 mb-2 flex items-center gap-2">
              <Mail className="h-5 w-5" />
              Need help?
            </h2>
            <p className="text-emerald-900 mb-0">
              Contact us at{" "}
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="font-semibold text-emerald-700 hover:underline"
                data-testid="refunds-support-email"
              >
                {SUPPORT_EMAIL}
              </a>{" "}
              for questions related to refunds and returns.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
